import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent, DesignBlockImageScope, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';
import { PhotoGalleryDesignBlockScope } from '../photo-gallery-design-block.component';

@Component({
    selector: 'lib-photo-gallery-design-block-item',
    templateUrl: './photo-gallery-design-block-item.component.html',
    styleUrls: ['./photo-gallery-design-block-item.component.scss'],
})
export class PhotoGalleryDesignBlockItemComponent extends BaseViewComponent implements DesignBlockImageScope {
    Scope = this.SetScope({
        Implements: DesignBlockImageScope,
        Requires: [PhotoGalleryDesignBlockScope, WebsitePageScope]
    });

    @Input() imageData!: WebsiteBlockTextAndMediaImageDisplayItem;
    @Input() isMiddleImageOfView: boolean = false;

    @Output() removePhotoGalleryItemClicked: EventEmitter<void> = new EventEmitter();

    override ngOnInit(): void {
        super.ngOnInit();

        if (![WebsiteBlockTextAndMediaType.PhotoGalleryCarousel, WebsiteBlockTextAndMediaType.PhotoGalleryCarouselOverlay,
              WebsiteBlockTextAndMediaType.PhotoGalleryGrid].includes(this.Scope.websiteBlockData.TextAndMediaType)) {
            throw Error('PhotoGalleryDesignBlockItemComponent used in wrong context');
        }
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.Scope.websiteBlockData.TextAndMediaType;
    }

    get WebsiteBlockTextAndMediaType(): typeof WebsiteBlockTextAndMediaType {
        return WebsiteBlockTextAndMediaType;
    }
}
